import React from "react";
import { TextField } from "@hdir/ui/text-field";
import { Button } from "@hdir/ui/button";
import { faSearch, faXmark } from "@fortawesome/pro-light-svg-icons";
import FontAwesomeIconWrapper from "../FontAwesomeIconWrapper/FontAwesomeIconWrapper";

import { ListSearchSearchComponentProps } from "../../../site/parts/listSearch/type.d";

export default function ListSearchSearchComponent(props: Readonly<ListSearchSearchComponentProps>) {
  const {
    fetchListOnSearchInput, setSearchQuery, searchInputRef, localizedForListSearch, title,
  } = props;

  // URL param for analytics only
  const updateUrlParam = (value: string) => {
    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set('q', value);
    } else {
      url.searchParams.delete('q');
    }
    window.history.pushState({}, '', url.toString());
  };

  // Sets states the handles search.
  const triggerSearch = (value: string) => {
    fetchListOnSearchInput(value);
    setSearchQuery(value);
    updateUrlParam(value);
  };

  const handleSearchSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (searchInputRef.current) {
      triggerSearch(searchInputRef.current.value);
      searchInputRef.current.blur();
    }
  };

  const emptySearch = () => {
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
      searchInputRef.current.focus();
    }
    triggerSearch('');
  };

  return (
    <div className="searchContainer pt-lg pb-xl tablet:pb-xxl px-md tablet:px-xxl rounded-md bg-surface-feedback-success">
      <form className="flex gap-md" onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="relative flex-1">
          <FontAwesomeIconWrapper className="absolute left-3 bottom-3 text-color-action-default pointer-events-none" size="lg" icon={faSearch} />
          <TextField
            label={title || (localizedForListSearch?.search ?? "Søk")}
            fullWidth
            className="searchInput !gap-sm text-lg font-bold"
            name="search"
            type="text"
            ref={searchInputRef}
          />
          { searchInputRef?.current?.value
            && (
              <button
                type="button"
                onClick={() => emptySearch()}
                aria-label={localizedForListSearch?.resetSearch ?? "Nullstill søk"}
                className="w-6 absolute right-3 bottom-2 text-color-action-default appearance-none bg-transparent border-none p-0 cursor-pointer"
              >
                <FontAwesomeIconWrapper size="lg" icon={faXmark} />
              </button>
            )}
        </div>
        <Button className="self-end" variant="primary" type="submit">
          {localizedForListSearch?.search ?? "Søk"}
        </Button>
      </form>
    </div>
  );
}
